import { axios } from "../../api/axiosDefault";
import { FORGOTPASSWORD, LOGIN, RESETPASSWORD } from "../../api/apiConfig";
import { CHANGEPASSWORD } from "../../api/apiConfig";
import { AnalyticsService } from "../../utils/Analytics";
//jwt token
export const login = async (data) => {
  return axios
    .post(LOGIN, data)
    .then((response) => {
      const res = response.data;
      if (res && res.data) {
        localStorage.setItem("access_token", res.data.jwtToken);
        localStorage.setItem("isAuthenticated", res.success);
        localStorage.setItem("userEmail", res.data.email);
        localStorage.setItem("userName", res.data.name);
        localStorage.setItem("hasChangedPassword", res.data.hasChangedPassword);
        localStorage.setItem("autoAcceptsOrders", res.data.autoAcceptsOrders);
        AnalyticsService.identifyUser(res.data.email);
        AnalyticsService.logEvent("USER_LOGGED_IN_SUCCESSFULLY");
        console.log(localStorage.getItem("hasChangedPassword"));
      }
      return res;
    })
    .catch(() => {
      return null;
    });
};
export const changePassword = async (data) => {
  return axios
    .post(CHANGEPASSWORD, data)
    .then((response) => {
      const res = response.data;
      if (res && res.data) {
        localStorage.setItem("access_token", res.data.jwtToken);
        localStorage.setItem("isAuthenticated", res.success);
        localStorage.setItem("userEmail", res.data.email);
        localStorage.setItem("userName", res.data.name);
        AnalyticsService.identifyUser(res.data.email);
        AnalyticsService.logEvent("USER_CHANGED_PASSWORD_SUCCESSFULLY");
      }
      return res;
    })
    .catch(() => {
      return null;
    });
};
export const forgotPassword = async (data) => {
  return axios
    .post(FORGOTPASSWORD, data)
    .then((response) => {
      const res = response.data;
      if (res && res.data) {
        AnalyticsService.logEvent("User_Request_Password_Reset");
      }
      return res;
    })
    .catch(() => {
      return null;
    });
};
export const resetPassword = async (data) => {
  return axios
    .post(RESETPASSWORD, data)
    .then((response) => {
      const res = response.data;
      if (res && res.data) {
        AnalyticsService.logEvent("User_Request_Password_Reset");
      }
      return res;
    })
    .catch(() => {
      return null;
    });
};
